module.exports = __webpack_public_path__ + "b5ca93f8fd0cdf236fe6d668fc25fefe.jpg";